import { useMemo } from 'react'

import { useReportData } from '../../../../hooks/useReportData'
import { PeriodValue } from '../../../../types/inputTypes'
import { useTrialBalanceFilters } from '../contexts/trialBalanceFiltersContext'
import { TrialBalanceInputBalance, TrialBalanceInputRowComponent } from '../types/inputTypes'
import { useFetchTrialBalanceReport } from './useFetchTrialBalanceData'

interface UseTrialBalanceDataReturn {
  allExpandableIds: string[]
  reportData: TrialBalanceInputRowComponent[]
  periods: PeriodValue[]
  isLoading: boolean
}

export const useTrialBalanceData = (): UseTrialBalanceDataReturn => {
  const { appliedFilters } = useTrialBalanceFilters()
  const { data, isLoading } = useFetchTrialBalanceReport({ appliedFilters })

  const { allExpandableIds, reportData, periods } = useReportData<TrialBalanceInputBalance>({
    data,
  })

  return useMemo(
    () => ({
      allExpandableIds,
      reportData,
      periods,
      isLoading,
    }),
    [allExpandableIds, reportData, periods, isLoading],
  )
}
